import {axiosWithHeaders} from './api'
import {expireSession} from "../redux/actions/authActions";
import {message} from "antd";
import HttpResponseStatus from "../constants/HttpResponseStatus";

const interceptor = (store) => {

    axiosWithHeaders.interceptors.request.use(function (config) {
        const token = localStorage.getItem('vlmToken');
        config.headers.Authorization = `Bearer ${token}`;
        return config;
    });

    axiosWithHeaders.interceptors.response.use((response) => {
        return response;
    }, (error) => {
        if (error.response && error.response.status === HttpResponseStatus.NOT_FOUND) {

        } else if (error.response && error.response.status === HttpResponseStatus.UNAUTHORIZED) {
            const darkMode = store.getState().theme.darkMode;
            const sessionExpired = store.getState().auth.sessionExpired;
            if (!sessionExpired) {
                message.error({
                    content: "Session expired",
                    className: darkMode && "dark-mode",
                    duration: 5
                });
                store.dispatch(expireSession());
            }
        }
        return Promise.reject(error);
    });
};

export default {
    interceptor
};